/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var fromOlChangeEvent = _interopDefault(require('./from-ol-change-event'));
var fromOlEvent = _interopDefault(require('./from-ol-event'));

/**
 * @module rx-ext
 */

exports.observableFromOlChangeEvent = fromOlChangeEvent;
exports.observableFromOlEvent = fromOlEvent;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/rx-ext/index.js
// module id = 1483
// module chunks = 1